<template>
  <div>
    <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
    <div v-else>
      <v-btn fab icon @click="$router.go(-1)" >
        <v-icon style="font-weight: bold; font-size: 2.5rem">chevron_left</v-icon>
      </v-btn>
      <v-layout>
        <v-flex md3 xs10> <SearchSort :sort-disable="true" :fullWidth="true" v-on:sort="sort($event)" v-on:search="search($event)" /></v-flex>
        <v-flex  offset-md8 md1 xs2>
          <v-icon @click="changeMode(1)"  :color="mode ==1 ? 'primary' : 'gray'" class="icon">toc</v-icon><!--    <v-icon>view_list</v-icon>-->
          <v-icon @click="changeMode(2)" :color="mode ==2 ? 'primary' : 'gray'" class="icon">view_list</v-icon>
          <v-icon @click="changeMode(3)" :color="mode ==3 ? 'primary' : 'gray'" class="icon">view_quilt</v-icon>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex   md1 xs2>
          <button @click="filterSection(0)"  :class="clickedSection == 0 ? 'btn-class btn-class_active':'btn-class btn-class_unactive' ">Wszystkie</button>
        </v-flex>
        <v-flex v-for="(section) in sections" :key="'section-' + section.id" md1 style="border-bottom: none" xs2>
          <button @click="filterSection(section.id)" :class="clickedSection == section.id ?  'btn-class btn-class_active':'btn-class btn-class_unactive' ">{{section.name}}</button>
        </v-flex>
      </v-layout>

      <div class="border_wrapper">
      <v-layout row wrap>
      <v-data-table v-if="mode == 1" :headers="headers" :items="documents" class="elevation-1" :loading="loading"
           no-data-text="Brak dokumentów" :rows-per-page-items="pagination.rowsPerPageItems"  :pagination.sync="pagination">

        <template v-slot:items="props">
          <td class="text-overflow">{{ props.item.id }}</td>
          <td class="text-overflow">{{ getUser(props.item.created_by).name }} {{ getUser(props.item.created_by).surname }}</td>
          <td class="text-overflow">{{ props.item.created_at }}</td>
          <td class="text-overflow">{{ props.item.schema.name }}</td>
          <td class="text-overflow">{{ props.item.document_id }}</td>
          <td class="text-overflow">{{props.item.document_date}}</td>
          <td class="text-overflow">{{props.item.expiration_date == '9999-12-31' ? 'Brak' : props.item.expiration_date}}</td>
          <td class="text-overflow">
            <v-icon :color="props.item.signed == 1 ? 'green darken-3' : 'red darken-3'">
              {{props.item.signed == 1  ? "mdi-pencil" : "mdi-pencil-off"}}
            </v-icon>
          </td>
          <td class="text-overflow">{{ getDocumentType(props.item.section_id) }}</td>
          <td>
            <v-btn
                :to="{ name : 'document-form-edit', params:{schemaId : props.item.schema.id, 'formId': props.item.form_id}}"
                icon small>
              <v-icon color="green darken-4">manage_search</v-icon>
            </v-btn>
            <v-btn
                :to="{ name : 'document-form-view-by-worker', params:{schemaId : props.item.schema.id, 'briefcase_guid': props.item.briefcase_guid }}"
                icon small>
              <v-icon color="green darken-2">view_carousel</v-icon>
            </v-btn>
            <v-btn :disabled="!(props.item.status == 2 || props.item.status ==3)" @click="generateDocumentFiles(props.item.id)" small  icon>
              <v-icon color="primary darken-2">print</v-icon>
            </v-btn>
            <CheckSignature :id-doc="props.item.id"></CheckSignature>
            <v-btn @click="deleteDocument(props.item.id)" small  icon>
              <v-icon color="red darken-2">delete_forever</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-card></v-card>
      </v-layout>

        <DocumentListView v-for="(document, key) in documents" v-if="mode == 2" :key="'document-' + key"
                          :item="document">
        <template v-slot:actions="{item}">
          <v-btn color="green darken-3" :to="{ name : 'document-form-edit', params:{schemaId : item.schema.id, 'formId': item.form_id}}" @click="goToWorkersSection(props.item.guid)" >
            Zobacz
          </v-btn>
          <v-btn color="green darken-2" :to="{ name : 'document-form-view-by-worker', params:{schemaId : item.schema.id, 'workerId': item.worker_guid}}" @click="goToWorkersSection(props.item.guid)" >
            Zobacz Wszystkie
          </v-btn>
        </template>
      </DocumentListView>

      <v-container  v-if="mode == 3" fluid grid-list-lg>
        <v-data-iterator
            :items="documents"
            :pagination.sync="cardPagination"
            :rows-per-page-items="cardPagination.rowsPerPageItems"
            content-tag="v-layout"
            no-data-text="Brak dokumentów"
            row
            wrap
        >
          <template v-slot:item="props">
            <v-flex lg4>
              <DocumentCardView   v-if="mode == 3" :item="props.item">
                <template v-slot:actions="{item}">
                  <v-btn color="green darken-3" :to="{ name : 'document-form-view-by-worker', params:{schemaId : item.schema.id, 'workerId': item.worker_guid}}" @click="goToWorkersSection(props.item.guid)" >
                    Zobacz
                  </v-btn>
                  <v-btn color="green darken-2" :to="{ name : 'document-form-view-by-worker', params:{schemaId : item.schema.id, 'workerId': item.worker_guid}}" @click="goToWorkersSection(props.item.guid)" >
                    Zobacz Wszystkie
                  </v-btn>
                </template>
              </DocumentCardView>
            </v-flex>
          </template>
        </v-data-iterator>
      </v-container>

      </div>
    </div>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import SearchSort from "@/components/common/SearchSort"
import DocumentListView from "@/components/document/DocumentListView"
import DocumentCardView from "@/components/document/DocumentCardView"
import DynamicCardView from "@/components/common/DynamicCardView"
import Vue from "vue"
import CheckSignature from "@/components/document/CheckSignature"

export default {
  name: "Sections",
  components: {CheckSignature, DynamicCardView, SearchSort, DocumentListView,DocumentCardView},
  data() {
    return {
      mode : 1,
      cardPagination: {
        page: 1,
        rowsPerPage: 3,
        rowsPerPageItems: [3,9,21]
      },
      pagination: this.$store.getters.pagination,
      documents : [],
      documentsAll : [],
      sections: [],
      clickedSection : 0,
      loading: true,
      headers: [
        {text : 'Id',value : 'id', width: "70px",align: 'center'},
        {text : 'Autor',align: 'center'},
        {text : 'Utworzono',value : 'created_at',align: 'center'},
        {text : 'Typ',value : 'schema.name',align: 'center'},
        {text : 'Id Dokumentu',value : 'document_id',align: 'center'},
        {text : 'Data dokumentu',value : 'document_date',align: 'center'},
        {text : 'Data wygaśnięcia',value : 'expiration_date',align: 'center'},
        {text : 'Podpis',value : 'status',width: "70px",align: 'left'},
        {text : 'Sekcja',value : 'section', width:"70px",align: 'left'},
        {text : 'Akcje',align: 'center'}
      ],
    }
  },
  created() {
    Vue.set(this.$router.currentRoute.matched[0].meta, 'title', `Dokumenty pracownika`)
    this.loadWorker()
    this.loadDocuments()
  },
  methods: {
    generateDocumentFiles(id){
      this.$http.get(`/document/${id}/download`, {responseType: 'blob'})
        .then(data => {
          let filename = this.getFilename(data)
          const url = window.URL.createObjectURL(new Blob([data.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          Messenger.emitSuccess("Rozpoczęto pobieranie")
        })
        .catch(() => Messenger.emitError("Bład przy pobieraniu dokumentu"));
    },
    getFilename(response){
      let filename = "Dokument.zip";
      let disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('attachment') !== -1) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      return filename
    },
    deleteDocument(id){
      this.$confirm("Czy jesteś pewien, że chcesz usunąć dokument? Operacja jest nieodwracalna.").then((res)=>{
        if(res) {
          this.$http.delete(`document/${id}`).then(() => {
            this.documents = this.documents.filter(doc => doc.id != id)
            Messenger.emitSuccess("Usunięto dokument")
          }).catch(() => Messenger.emitError("Nie można usunąć dokumentu"))
        }
      })
    },
    search(event){
      let regex = new RegExp('.*(' + event.search + ').*', "i");
      this.documents = this.documentsAll.filter(doc =>{
        return regex.test(doc.schema.name) || regex.test(doc.created_at) ||
            regex.test(this.getUser(doc.created_by).name) || regex.test(this.getUser(doc.created_by).surname)
      })
    },
    filterSection(idSection){
      this.clickedSection = idSection
      if(idSection == 0){
        return this.documents = this.documentsAll
      }
      this.documents = this.documentsAll.filter(doc => doc.section_id == idSection)
    },
    changeMode(mode){
      this.mode = mode
    },
    getUser(id){
      return this.$store.getters.user(id) || {}
    },
    getDocumentType(idSection){
      return this.sections.length > 0 && idSection ? this.sections.find(section => section.id == idSection).name : ""
    },
    goToSchemas(idSection){
      let workerId = this.$route.params.workerId
      let path = '/documents'
      if(workerId){
        path += '/worker/' + workerId
      }
      path += `/section/${idSection}`

      this.$router.push({path : path})
    },
    loadDocuments() {
      let briefcaseGuid = this.$route.params.briefcaseGuid
      this.$http.get('/document/briefcase/'+ briefcaseGuid +'/all').then(data =>{
        this.documents = data.data
        this.documentsAll = data.data
        // this.cardPagination.totalItems = data.data.length
      })
      this.$http.get('/document/section').then(data => {
        this.sections = data.data
      }).finally(() => this.loading = false)
    },
    loadWorker(){
      this.$http.get('document/briefcase/' + this.$route.params.briefcaseGuid).then(data =>{
        this.$http.get('document/worker/' + data.data.worker_guid).then((data)=>{
          Vue.set(this.$router.currentRoute.matched[0].meta, 'title', `Dokumenty pracownika: ${data.data.name} ${data.data.surname}`)
        })
      }).catch(() => Messenger.emitError("Problem z załadowaniem pracownika"))
    }
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'SeymourOne';
  src: url('~@/assets/fonts/SeymourOne-Regular.ttf');
}

.btn-class {
  border : 1px solid rgba(10, 10, 10, 0.10);
  border-bottom: none;
  width: 100%;
  font-size: 1rem;
  padding: 0.3rem 0.3rem 0.3rem;
}
.btn-class_unactive{
  background-color: #fffcfc !important;
}

.border_wrapper{
  border: 1px solid rgba(10, 10, 10, 0.10);
  margin-top: -1px;
}
.text-overflow {
  text-align: center;
  word-wrap: break-word;
  vertical-align: middle;
  white-space: normal;
}
.btn-class_active{
  font-weight: bold;
  background-color: #fffdf4 !important;
  border : 1px solid rgba(10, 10, 10, 0.50);
  border-bottom: 1px solid white;
}
.btn-class:hover {
  background-color: #ababab;

}
</style>